/** Unwrap the query response from the axios wrapper if needed (hooks return the full response). */
export function unwrap<T>(data: unknown): T | undefined {
  return ((data as { data?: T })?.data ?? data) as T | undefined
}
